// Human wording for the simple cron schedules the admin pages set:
// "0 6 * * *" -> "daily at 06:00", "0 4,16 * * *" -> "daily at 04:00 and 16:00",
// "0 6 * * 1" -> "Mondays at 06:00". Anything else is shown as the raw expression.
const DAYS = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays']

export function describeCron (cron) {
  const text = String(cron || '').trim()
  const pad = (value) => String(value).padStart(2, '0')
  let match = /^(\d{1,2}) (\d{1,2}(?:,\d{1,2})*) \* \* \*$/.exec(text)
  if (match) {
    const times = match[2].split(',').map((hour) => `${pad(hour)}:${pad(match[1])}`)
    const last = times.pop()
    return `daily at ${times.length ? `${times.join(', ')} and ${last}` : last}`
  }
  match = /^(\d{1,2}) (\d{1,2}) \* \* ([0-6])$/.exec(text)
  if (match) return `${DAYS[Number(match[3])]} at ${pad(match[2])}:${pad(match[1])}`
  return text ? `on schedule "${text}"` : ''
}
